// extracted by mini-css-extract-plugin
module.exports = {"gridItem":"az_Wob","question":"az_Xob","answer":"az_Yob","accordionItem":"az_Zob"};